// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"application_wrapper___yuvC","title":"application_title__5RyEB"};